import {getClubPublicInfo} from '@/api/api';
import {Club} from '@/api/Director/club.interface';
import {useQuery} from '@tanstack/react-query';

export const useGetClubPublicInfo = ({clubId}: {clubId?: string}) => {
  return useQuery<Partial<Club>>({
    queryKey: ['club-public', clubId],
    queryFn: () => getClubPublicInfo({clubId}),
    enabled: !!clubId,
  });
};
